{
  "actions": {
    "addToCart": "Toevoegen aan winkelwagen",
    "close": "Sluiten",
    "nextStep": "Volgende stap",
    "savingDesign": "Ontwerp opslaan...",
    "posterAdded": "Poster toegevoegd",
    "retry": "Opnieuw proberen"
  },
  "shipping": {
    "beforeNoon": "Voor 12:00 u. besteld, vandaag verzonden",
    "tomorrow": "Vandaag besteld, morgen verzonden",
    "onDate": "Vandaag besteld, {date} verzonden"
  },
  "components": {
    "fontOptions": {
      "title": "Lettertype",
      "modern": "Modern",
      "classic": "Klassiek",
      "mono": "Mono"
    },
    "mapStyleSelector": {
      "modern": "Modern",
      "black": "Zwart",
      "ocean": "Oceaan",
      "sketch": "Schets",
      "beige": "Beige",
      "color": "Kleur",
      "chic": "Chic",
      "gray": "Grijs",
      "delft": "Delft"
    },
    "kaderSelector": {
      "title": "Kies een kader",
      "none": "Geen",
      "classic": "Klassiek",
      "heart": "Hart",
      "circle": "Cirkel",
      "delft": "Delft"
    },
    "orientationSelector": {
      "title": "Kies een oriëntatie",
      "portrait": "Staand",
      "landscape": "Liggend"
    },
    "materialToggle": {
      "title": "Product en formaat",
      "paper": "Premium poster",
      "paperAlt": "Papieren print",
      "acryl": "Print op acrylglas",
      "aluminium": "Print op aluminium",
      "tile": "Handgebakken tegeltje",
      "from": "Vanaf",
      "changeMaterial": "Kies een ander materiaal"
    },
    "productOptions": {
      "chooseSize": "Kies je formaat",
      "inCentimeters": "in centimeters",
      "mostPopular": "Meest gekozen",
      "black": "Zwart",
      "oak": "Eiken"
    },
    "paperOptions": {
      "chooseFrame": "Kies je lijst",
      "frameHelp": "Onze FSC® gecertificeerde posterlijsten zijn gemaakt van solide hardhout (geen MDF) en zijn voorzien van ontspiegeld acrylglas.",
      "noFrame": "Zonder lijst (zelf inlijsten)",
      "frameInfo": "Een goede lijst maakt het verschil. Geef je poster de uitstraling die hij verdient."
    },
    "acrylOptions": {
      "transparencyInfo": "Al het wit in het ontwerp wordt transparant.",
      "chooseStand": "Kies je standaard",
      "noStand": "Zonder standaard (los neerzetten)"
    },
    "aluminiumOptions": {
      "chooseColor": "Kies je aluminiumkleur",
      "silver": "Zilver",
      "gold": "Goud",
      "bronze": "Brons",
      "rose": "Rosé",
      "transparencyInfo": "Al het wit in het ontwerp wordt transparant en krijgt de kleur van het aluminium.",
      "chooseMount": "Kies je hanger of standaard",
      "hanger": "Hanger",
      "noMount": "Zonder hanger of standaard"
    },
    "tileOptions": {
      "chooseAccessory": "Kies een accessoire",
      "blackFrame": "Zwarte lijst",
      "oakFrame": "Eiken lijst",
      "blackStand": "Zwarte houder",
      "oakStand": "Eiken houder",
      "noAccessory": "Zonder accessoire"
    },
    "giftOptions": {
      "giftwrapLabel": "Cadeauverpakking",
      "withoutGiftwrap": "Zonder cadeauverpakking",
      "withGiftwrap": "Met cadeauverpakking + {price}",
      "giftcardLabel": "Kaartje",
      "withoutCard": "Zonder kaartje",
      "withCard": "Met kaartje + {price}",
      "messagePlaceholder": "Vul hier je persoonlijke boodschap in..."
    },
    "shoppingBag": {
      "printTypes": {
        "paper": "Premium poster",
        "acryl": "Print op acrylglas",
        "aluminium": "Aluminium print",
        "tile": "Handgebakken tegeltje"
      },
      "frames": {
        "black": "Zwarte lijst",
        "oak": "Eiken lijst",
        "white": "Witte lijst"
      }
    },
    "trustpilot": {
      "reviewUrl": "https://nl.trustpilot.com/review/wallable.nl?utm_medium=Trustbox&utm_source=EmailSignature2",
      "ratingImageUrl": "https://emailsignature.trustpilot.com/signature/nl-NL/2/625eee8d230116b4f2ab2f13/text.png",
      "starsImageUrl": "https://emailsignature.trustpilot.com/signature/nl-NL/2/625eee8d230116b4f2ab2f13/stars.png",
      "ratingAlt": "Trustpilot-beoordeling",
      "starsAlt": "Trustpilot-sterren",
      "logoAlt": "Trustpilot-logo"
    },
    "markerOptions": {
      "reorder": "Sleep om de volgorde te wijzigen, of gebruik de pijltjestoetsen. Bovenste pin ligt bovenop.",
      "location": "Locatie",
      "size": "Formaat",
      "centerPin": "Pin(s) centreren",
      "removeConfirmation": "Weet je zeker dat je deze pin wilt verwijderen?",
      "confirmRemove": "Ja, verwijder",
      "cancelRemove": "Nee, annuleer",
      "chooseIcon": "Kies een icoon en kleur voor je pin:",
      "color": "Kleur van de pin",
      "pinSize": "Formaat pin:",
      "searchPlaceholder": "Zoek een adres, stad of dorp…"
    },
    "zoomToast": {
      "title": "Zoomen & Verplaatsen",
      "description": "Je kunt de kaart verplaatsen en in- en uitzoomen met de muis of je vingers."
    }
  },
  "errors": {
    "generic": "Er ging iets mis. Probeer het opnieuw.",
    "routeUnavailable": "De route kon niet worden geladen. Je kunt verder ontwerpen of een andere route kiezen.",
    "routesUnavailable": "De routes konden niet worden geladen. Vernieuw de pagina en probeer het opnieuw of neem contact op."
  },
  "cityMap": {
    "productUrl": "https://wallable.nl/product/persoonlijke-kaartposter/",
    "defaults": {
      "city": "Zwolle",
      "region": "Overijssel, Nederland"
    },
    "common": {
      "addImagePin": "Pin toevoegen (met foto)",
      "textTitle": "Tekst op je ontwerp",
      "text": "Tekst",
      "showCoordinates": "Toon coördinaten",
      "map": "Kaart",
      "loading": "Ontwerp laden..."
    },
    "meta": {
      "title": "Ontwerp jouw Dorp- of Stadsposter",
      "description": "Ontwerp een persoonlijke stadskaartposter van jouw bijzondere locatie.",
      "ogTitle": "Persoonlijke stadskaartposter - Wallable"
    },
    "fields": {
      "coordinates": "Coördinaten",
      "location": "Plaatsnaam",
      "subtitle": "Provincie, Land",
      "subtitle2": "Extra tekst (bijv. namen)",
      "subtitle3": "Extra tekst (bijv. verhuisdatum)"
    }
  },
  "housewarming": {
    "productUrl": "https://wallable.nl/product/housewarming-poster/",
    "meta": {
      "title": "Ontwerp je eigen housewarmingposter!",
      "description": "Ontwerp een persoonlijke housewarmingposter van een bijzondere woning en locatie.",
      "ogTitle": "Persoonlijke housewarmingposter - Wallable"
    },
    "fields": {
      "coordinates": "Coördinaten",
      "location": "Plaatsnaam",
      "subtitle": "Provincie, Land",
      "subtitle2": "Extra tekst (bijv. verhuisdatum)",
      "subtitle3": "Extra tekst (aangeboden door ...)"
    }
  },
  "realtor": {
    "productUrl": "https://wallable.nl/product/relatiegeschenk-makelaar/",
    "meta": {
      "title": "Ontwerp je Makelaar Stadskaart",
      "description": "Ontwerp een persoonlijke woningposter als uniek cadeau van de makelaar.",
      "ogTitle": "Persoonlijke makelaarsposter - Wallable"
    },
    "fields": {
      "coordinates": "Coördinaten",
      "location": "Plaatsnaam",
      "subtitle": "Provincie, Land",
      "subtitle2": "Extra tekst (bijv. verhuisdatum)",
      "subtitle3": "Aangeboden door ..."
    },
    "product": {
      "title": "Formaat en lijst",
      "framedPoster": "Ingelijste poster"
    }
  },
  "specialLocation": {
    "productUrl": "https://wallable.nl/product/bijzondere-locatie-poster/",
    "chooseEvent": "Kies een gebeurtenis",
    "meta": {
      "title": "Ontwerp je eigen speciale locatieposter!",
      "description": "Ontwerp een persoonlijke poster van een bijzondere locatie en gebeurtenis.",
      "ogTitle": "Persoonlijke speciale locatieposter - Wallable"
    },
    "fields": {
      "coordinates": "Coördinaten",
      "location": "Gebeurtenis",
      "subtitle": "Locatie",
      "subtitle2": "Datum",
      "subtitle3": "Extra tekst"
    }
  },
  "hyrox": {
    "productUrl": "https://wallable.nl/product/hyrox-poster/",
    "meta": {
      "title": "Ontwerp je HYROX aandenken",
      "description": "Maak een persoonlijke HYROX-print van jouw prestatie.",
      "ogTitle": "Maak je eigen HYROX-print - Wallable"
    },
    "event": {
      "title": "Selecteer een event",
      "description": "Hieronder vind je een lijst met events die bij ons bekend zijn. Je kunt ze inladen door op het event te klikken.",
      "search": "Zoek naar een HYROX-event...",
      "searchAction": "Zoek je HYROX-event",
      "division": "Kies divisie",
      "ageGroup": "Kies een leeftijdsgroep",
      "noResults": "Helaas, we konden niets vinden. Probeer een andere zoekterm of neem contact op."
    },
    "photo": {
      "choose": "Kies een foto",
      "help": "Open een foto en selecteer het deel dat je wilt zien.",
      "open": "Foto openen",
      "save": "Opslaan",
      "poorQuality": "Matige kwaliteit afbeelding",
      "qualityAdvice": "We adviseren een afbeelding toe te voegen met een hogere resolutie.",
      "edit": "Foto aanpassen"
    },
    "editor": {
      "title": "Personaliseer je print",
      "subtitle": "Druk op de onderstaande knop om een HYROX event te zoeken en de gegevens in te laden.",
      "location": "Locatie",
      "abbreviation": "Afkorting",
      "participant": "Naam deelnemer",
      "finishTime": "Finishtijd",
      "date": "Datum",
      "division": "Divisie",
      "ageGroup": "Leeftijdsgroep",
      "defaultName": "Jouw naam",
      "defaultAgeGroup": "30-34 jaar",
      "defaultFinishTime": "Jouw tijd"
    },
    "shopTitle": "Jouw HYROX-print",
    "actions": { "savingImage": "Afbeelding opslaan..." },
    "errors": {
      "photoSaveFailed": "De foto kon niet worden opgeslagen. Neem contact op via de chat voor hulp.",
      "previewSaveFailed": "De preview kon niet worden opgeslagen. Probeer het opnieuw."
    }
  },
  "lovemap": {
    "productUrl": "https://wallable.nl/product/lovemap-poster/",
    "meta": {
      "title": "Ontwerp je eigen lovemap",
      "description": "Maak een persoonlijke liefdeskaart van jullie bijzondere locaties.",
      "ogTitle": "Maak je eigen lovemapposter - Wallable"
    },
    "map": {
      "title": "Kies de locaties voor je poster",
      "layout": "Kies een lay-out",
      "blackWhiteHeart": "Zwart-wit hart (2 locaties)",
      "blackHeart": "Zwart hart (1 locatie)",
      "whiteHeart": "Wit hart (1 locatie)",
      "left": "Locatie links (zwart)",
      "right": "Locatie rechts (wit)",
      "location": "Locatie",
      "nightLeft": "Locatie links (nacht)",
      "help": "Je kunt de kaart(en) verplaatsen en zoomen met je muis of vingers."
    },
    "editor": {
      "title": "Personaliseer je poster",
      "text": "Tekst",
      "names": "Naam & naam",
      "location": "Locatie",
      "date": "Datum",
      "color": "Kies een kleur",
      "font": "Kies een lettertype",
      "help": "Je kunt tekstregels leeg laten als je ze niet wilt gebruiken of de tekst verplaatsen naar een andere regel. Emoji worden niet ondersteund."
    },
    "product": {
      "title": "Formaat en extra's",
      "size": "Kies een formaat",
      "frame": "Kies een lijst",
      "bestseller": "Bestseller",
      "noFrame": "Zonder lijst",
      "blackFrame": "Zwarte lijst (hardhout)",
      "oakFrame": "Naturel lijst (eiken)"
    },
    "defaults": {
      "names": "Naam & Naam",
      "location": "Locatie",
      "date": "Datum"
    },
    "concept": {
      "line1": "De hierboven afgebeelde poster is ook je concept.",
      "line2": "Je krijgt hem precies zoals je hem ziet."
    },
    "errors": {
      "previewFailed": "De preview kon niet worden opgeslagen. Probeer het opnieuw."
    }
  },
  "mothersDay": {
    "productUrl": "https://wallable.nl/product/moederdag-city-map-poster/",
    "meta": {
      "title": "Ontwerp je eigen moederdagposter",
      "description": "Maak een persoonlijke moederdagposter met een bijzondere locatie.",
      "ogTitle": "Persoonlijke moederdagposter - Wallable"
    },
    "editor": {
      "title": "Maak je eigen poster",
      "personalize": "Personaliseer je poster",
      "pin": "Locatiepin",
      "withoutPin": "Zonder locatiepin",
      "pinColor": "Kleur van de pin",
      "dragPin": "Pin zelf verslepen",
      "style": "Kies een stijl",
      "text": "Tekst",
      "coordinates": "Coördinaten",
      "headline": "Titel",
      "location": "Locatie",
      "extra": "Extra tekst (optioneel)",
      "font": "Lettertype",
      "heartColor": "Kleur van het hart",
      "circleColor": "Kleur van de cirkel"
    },
    "product": {
      "title": "Formaat en extra's",
      "size": "Formaat",
      "frame": "Lijst",
      "bestseller": "Bestseller"
    }
  },
  "fathersDay": {
    "productUrl": "https://wallable.nl/product/vaderdag-city-map-poster/",
    "meta": {
      "title": "Ontwerp je eigen vaderdagposter",
      "description": "Maak een persoonlijke vaderdagposter met een bijzondere locatie en foto.",
      "ogTitle": "Persoonlijke vaderdagposter - Wallable"
    },
    "photo": {
      "choose": "Kies een foto",
      "help": "Open een foto en selecteer het deel dat in de pin moet.",
      "inPin": "Foto in de pin",
      "poorQuality": "Slechte kwaliteit afbeelding"
    },
    "editor": {
      "locationTitle": "Kies je locatie",
      "personalize": "Personaliseer je ontwerp",
      "pin": "Locatiepin",
      "withPin": "Met locatiepin",
      "iconPin": "Pin met icoon",
      "photoPin": "Pin met foto",
      "pinColor": "Kleur van de pin",
      "dragPin": "Pin zelf verslepen",
      "style": "Stijl",
      "orientation": "Oriëntatie",
      "portrait": "Staand",
      "landscape": "Liggend",
      "moustache": "Snor toevoegen",
      "text": "Tekst",
      "coordinates": "Coördinaten",
      "headline": "Titel",
      "location": "Locatie",
      "extra": "Extra tekst (optioneel)",
      "font": "Lettertype"
    },
    "actions": { "savingImage": "Afbeelding opslaan..." }
  },
  "psalm": {
    "productUrl": "https://wallable.nl/product/psalm-poster/",
    "meta": {
      "title": "Ontwerp je Psalm poster",
      "description": "Maak een persoonlijke poster van een psalm.",
      "ogTitle": "Maak je eigen psalmposter - Wallable"
    },
    "archive": {
      "title": "Selecteer een psalm",
      "description": "Hieronder vind je een lijst met psalmen die bij ons bekend zijn. Klik op een psalm om deze te laden en pas daarna de tekst naar wens aan.",
      "search": "Zoek naar een psalm...",
      "choose": "Kies een psalm uit ons archief",
      "noResults": "Helaas, we konden niets vinden."
    },
    "editor": {
      "title": "Personaliseer je poster",
      "text": "Tekst",
      "help": "Verander hieronder de tekst op je poster",
      "psalm": "Psalm",
      "description": "Tekst van de psalm...",
      "defaultReference": "Psalm 23:3",
      "defaultText": "Hij voert mij naar vredige wateren, verkwikt mijn ziel, En leidt mij in het rechte spoor, om wille van zijn Naam."
    }
  },
  "dictionary": {
    "productUrl": "https://wallable.nl/product/jouw-woord-woordenboekposter/",
    "meta": {
      "title": "Ontwerp je Woordenboekposter",
      "description": "Maak een persoonlijke woordenboekposter van jouw bijzondere woord.",
      "ogTitle": "Maak je eigen woordenboekposter - Wallable"
    },
    "archive": {
      "title": "Selecteer een woord",
      "description": "Hieronder vind je een lijst met woorden die bij ons bekend zijn. Klik op een woord om het te laden en pas daarna de tekst naar wens aan.",
      "search": "Zoek naar een woord...",
      "choose": "Kies een woord uit ons archief",
      "noResults": "Helaas, we konden niets vinden."
    },
    "editor": {
      "title": "Personaliseer je poster",
      "text": "Tekst",
      "help": "Verander hieronder de tekst op je poster",
      "word": "Woord",
      "pronunciation": "Uitspraak",
      "type": "Woordsoort",
      "description": "Omschrijving van het woord...",
      "defaultWord": "Jouw woord",
      "defaultPronunciation": "[Uitspraak]",
      "defaultType": "Woordtype",
      "defaultDescription": "Definitie van jouw woord..."
    }
  },
  "photoGift": {
    "productUrl": "https://wallable.nl/product/maak-zelf-jouw-foto-print/",
    "meta": {
      "title": "Ontwerp jouw fotogeschenk",
      "description": "Maak een uniek fotogeschenk met je eigen foto, stijl en persoonlijke tekst.",
      "ogTitle": "Maak je eigen fotoprint - Wallable"
    },
    "photo": {
      "choose": "Kies een foto",
      "cropHelp": "Open een foto en selecteer het deel dat je wilt zien.",
      "open": "Foto openen",
      "save": "Opslaan",
      "edit": "Foto aanpassen",
      "chooseStyle": "Kies een stijl",
      "aiHelpBefore": "Onze digitale kunstenaar is nog aan het leren. Hierdoor kan het zijn dat sommige transformaties mislukken. Neem in dit geval",
      "contact": "contact",
      "aiHelpAfter": "op zodat wij je kunnen helpen.",
      "orientation": "Oriëntatie",
      "portrait": "Staand",
      "landscape": "Liggend"
    },
    "text": {
      "title": "Jouw tekst",
      "show": "Tekst toevoegen aan print",
      "top": "Extra tekst boven",
      "headline": "Titel",
      "subtitle": "Ondertitel",
      "bottom": "Extra tekst onder",
      "help": "Je kunt de velden leeg laten als je ze niet wilt gebruiken.",
      "defaultHeadline": "Jouw titel",
      "defaultSubtitle": "Jouw ondertitel"
    },
    "transform": {
      "none": "Geen",
      "delft": "Delft",
      "watercolor": "Aquarel",
      "cartoon": "Cartoon",
      "charcoal": "Houtskool",
      "vintage": "Vintage",
      "starting": "Starten met transformatie",
      "progress1": "Je foto wordt omgetoverd... ✨",
      "progress2": "We maken nu de gekozen stijlversie van je foto 🎨",
      "progress3": "Onze digitale kunstenaar is druk aan het schilderen...",
      "progress4": "Nog een paar penseelstreken voor het perfecte resultaat 🖌️",
      "progress5": "Bijna klaar! Goede kunst kost soms nét wat extra tijd."
    },
    "errors": {
      "transformFailed": "De fototransformatie is mislukt. Probeer het opnieuw.",
      "photoSaveFailed": "De foto kon niet worden opgeslagen. Neem contact op via de chat voor hulp.",
      "photoRequired": "Upload eerst een foto."
    },
    "actions": {
      "savingImage": "Afbeelding opslaan..."
    },
    "navigation": {
      "photo": "Foto",
      "text": "Tekst"
    }
  },
  "datePoster": {
    "productUrl": "https://wallable.nl/product/datumposter/",
    "meta": {
      "title": "Ontwerp jouw Datum poster",
      "description": "Breng een bijzondere datum tot leven met een persoonlijke datum poster.",
      "ogTitle": "Maak je eigen speciale datum poster - Wallable"
    },
    "editor": {
      "title": "Maak je eigen ontwerp",
      "textTitle": "Tekst",
      "textHelp": "Verander hieronder de tekst op je poster",
      "day": "Dag",
      "month": "Maand",
      "year": "Jaar",
      "event": "Iets bijzonders",
      "names": "Naam & Naam",
      "chooseColor": "Kies je kleur"
    },
    "navigation": {
      "personalize": "Personaliseer"
    },
    "defaults": {
      "event": "Gebeurtenis",
      "names": "Naam & Naam"
    }
  },
  "starmap": {
    "productUrl": "https://wallable.nl/product/sterrenkaart-poster/",
    "meta": {
      "title": "Ontwerp jouw Sterrenkaart",
      "description": "Maak een persoonlijke sterrenkaartposter van een bijzonder moment.",
      "ogTitle": "Maak je eigen sterrenkaartposter - Wallable"
    },
    "editor": {
      "title": "Maak je eigen sterrenkaart",
      "chooseDateTime": "Kies een datum en tijd",
      "showTime": "Tijd tonen",
      "noTimeHelp": "Wanneer je geen tijd aangeeft, laten we de sterrenhemel om middernacht zien.",
      "chooseText": "Kies een tekst"
    },
    "fields": {
      "coordinates": "Coördinaten",
      "moment": "Jouw bijzondere moment",
      "dateTime": "Datum en tijd",
      "extraText": "Extra tekst (optioneel)"
    },
    "date": {
      "year": "Jaar",
      "month": "Maand",
      "day": "Dag"
    },
    "style": {
      "title": "Personaliseer je ontwerp",
      "chooseFont": "Kies een lettertype",
      "chooseColor": "Kies je kleur",
      "chooseBackground": "Kies je achtergrondkleur",
      "light": "Licht",
      "dark": "Donker",
      "chooseBorder": "Kies je kader",
      "withBorder": "Met kader",
      "withoutBorder": "Zonder kader",
      "customizeSky": "Pas je sterrenhemel aan",
      "constellations": "Sterrenbeelden",
      "milkyWay": "Melkweg",
      "grid": "Raster"
    },
    "navigation": {
      "moment": "Moment",
      "style": "Stijl"
    },
    "defaults": {
      "event": "Gebeurtenis",
      "customMoment": "Anders (hieronder zelf schrijven)"
    },
    "moments": {
      "1": "Jij & Ik",
      "2": "Eerste kus",
      "3": "Toen de sterren op één lijn stonden",
      "4": "Waar het allemaal begon",
      "5": "Liefde onder de sterren",
      "6": "Toen we trouwden",
      "7": "Een ster werd geboren die nacht",
      "8": "Sterrenhemel tijdens je geboorte",
      "9": "De nacht waarin jij ter wereld kwam",
      "10": "Toen ik geboren ben",
      "11": "Toen de vonk oversloeg",
      "12": "Het moment waarop we 'ja' zeiden",
      "13": "Ons huis onder de sterren",
      "14": "Toen de sterren op één lijn stonden",
      "15": "Jij & Ik",
      "16": "Waar het gebeurde",
      "17": "Waar het allemaal begon",
      "18": "Eerste date",
      "19": "Toen we elkaar ontmoetten",
      "20": "Toen het allemaal begon",
      "21": "Eerste kus",
      "22": "Toen zij ja zei",
      "23": "Toen hij ja zei",
      "24": "Toen ik geboren ben"
    }
  },
  "songtext": {
    "productUrl": "https://wallable.nl/product/songtekst-lyrics-poster/",
    "meta": {
      "title": "Ontwerp jouw Songtekst print",
      "description": "Maak een persoonlijke poster met de songtekst van jouw favoriete nummer.",
      "ogTitle": "Maak je eigen songtekstposter - Wallable"
    },
    "search": {
      "loading": "Songtekst laden",
      "loadingHelp": "Dit kan even duren, dus heb geduld :)",
      "title": "Zoek een songtekst",
      "description": "Gebruik het zoekveld om naar een nummer te zoeken.",
      "placeholder": "Titel of artiestnaam",
      "action": "Zoeken",
      "error": "Sorry, we konden de songtekst niet laden. Probeer het nogmaals of neem contact met ons op.",
      "noResults": "Helaas, we konden niets vinden."
    },
    "editor": {
      "introduction": "Gebruik onderstaande knop om een songtekst uit onze database te laden of vul je eigen tekst in.",
      "title": "Personaliseer je tekst",
      "songName": "Naam van het nummer",
      "artist": "Naam artiest",
      "extraText": "Extra tekst (optioneel)",
      "lyrics": "Deel van de songtekst...",
      "maxCharacters": "Maximum aantal tekens bereikt.",
      "defaultArtist": "Artiest",
      "defaultSong": "Favoriete nummer",
      "defaultLyrics": "Songtekst van jouw favoriete lied. Gebruik de zoekfunctie om een songtekst te vinden of typ je eigen tekst."
    },
    "style": {
      "image": "Afbeelding",
      "icon": "Icoon",
      "cover": "Cover / Foto",
      "chooseIcon": "Kies een icoon en kleur:",
      "iconColor": "Kleur van het icoon",
      "color": "Kleur",
      "colorWarning": "Kleuren kunnen alleen worden gekozen voor een print op papier (Premium poster)"
    },
    "spotify": {
      "title": "Spotify-code",
      "show": "Spotify-code tonen",
      "placeholder": "Spotify-link",
      "invalid": "Ongeldige Spotify-link.",
      "tooltip": "Open de Spotify-app, ga naar Zoeken en scan de code op de print om het nummer direct te openen.",
      "help": "Je vindt de Spotify-link van een nummer via Delen en Link kopiëren in de Spotify-app. Plak de link vervolgens in het bovenstaande veld."
    },
    "actions": {
      "copyUrl": "Kopieer poster-URL"
    },
    "navigation": {
      "lyrics": "Songtekst",
      "style": "Stijl"
    }
  },
  "corporateGift": {
    "productUrl": "https://wallable.nl/product/bedrijfsgeschenk-met-logo/",
    "loading": "Ontwerp laden...",
    "meta": {
      "title": "Ontwerp jouw relatiegeschenk stadskaart",
      "description": "Geef een persoonlijk relatiegeschenk met een unieke kaart van een bijzondere bedrijfslocatie.",
      "ogTitle": "Maak je eigen relatiegeschenk city map poster - Wallable"
    },
    "photo": {
      "title": "Kies een foto",
      "description": "Open een foto en selecteer het deel dat in de pin moet.",
      "open": "Foto openen",
      "save": "Opslaan"
    },
    "map": {
      "title": "Locatie en markeringen",
      "markerLabel": "Postermarkering",
      "withoutPins": "Zonder locatiepin(s)",
      "withPins": "Met locatiepin(s)",
      "yourPins": "Jouw locatiepin(s)",
      "dragPins": "Pin(s) zelf verslepen",
      "dragPinsHelp": "Staat de locatiepin niet helemaal goed? Ontgrendel de pins en sleep de pin naar de juiste locatie.",
      "addPins": "Extra pins toevoegen",
      "addIconPin": "Pin toevoegen (met icoon)",
      "addImagePin": "Pin toevoegen (met foto of logo)"
    },
    "text": {
      "title": "Tekst op jouw ontwerp",
      "coordinates": "Coördinaten",
      "showCoordinates": "Toon coördinaten",
      "location": "Plaatsnaam",
      "company": "Bedrijfsnaam",
      "date": "Opening/Verhuisdatum",
      "offeredBy": "Aangeboden door ...",
      "help": "Je kunt tekstregels leeg laten als je ze niet wilt gebruiken of de tekst verplaatsen naar een andere regel. Emoji worden niet ondersteund."
    },
    "navigation": {
      "map": "Kaart",
      "text": "Tekst"
    }
  },
  "sportsmap": {
    "productUrl": "https://wallable.nl/product/sportprestatie-poster/",
    "defaultRouteName": "Sportroute",
    "genericRouteName": "Route",
    "loading": "Print laden...",
    "routeFile": "Het routebestand",
    "meta": {
      "title": "Ontwerp je eigen sportposter 💪",
      "description": "Breng je meest gedenkwaardige sportprestatie tot leven met een gepersonaliseerde routeposter.",
      "ogTitle": "Jouw sportprestatieposter - Uniek en gepersonaliseerd"
    },
    "gpx": {
      "title": "Hoe kom ik aan een GPX-bestand?",
      "introduction": "Een GPX-bestand bevat de route die je hebt gelopen, gefietst of gewandeld. Kies hieronder de app waarin je activiteit staat en volg de stappen rustig één voor één.",
      "generalTip": "Je kunt dit gewoon op je telefoon doen. Bij Komoot kan het rechtstreeks in de app. Voor Strava, Runkeeper, Garmin Connect en Polar Flow gebruik je de website in Safari of Chrome.",
      "strava": {
        "label": "Van Strava",
        "notice": "In de Strava-app ontbreekt de downloadknop. Volg deze stappen in Safari of Chrome op je telefoon.",
        "step1": "Open www.strava.com in Safari of Chrome en log in.",
        "step2": "Open de desktopversie van de website. Op een iPhone tik je in Safari links van de adresbalk op de knop voor het paginamenu en daarna op ‘Vraag om desktopwebsite’. In Chrome op Android tik je op de drie puntjes en vink je ‘Desktopsite’ aan.",
        "step3": "Open het Strava-menu, kies ‘Training’ en daarna ‘Mijn activiteiten’. Tik op de activiteit die je op de poster wilt zetten.",
        "step4": "Tik op de drie puntjes (•••) op de pagina van de activiteit en kies ‘GPX exporteren’. Kies daarna Downloads of Bestanden wanneer je telefoon vraagt waar het bestand moet worden bewaard."
      },
      "komoot": {
        "label": "Van Komoot",
        "notice": "Deze stappen kun je rechtstreeks in de Komoot-app uitvoeren.",
        "step1": "Open de Komoot-app en tik onderaan op ‘Profiel’.",
        "step2": "Open ‘Geplande tours’ of ‘Voltooide activiteiten’ en tik op de route die je op de poster wilt zetten.",
        "step3": "Tik bij de route op ‘GPX-bestand downloaden’.",
        "step4": "Op Android wordt het bestand meestal automatisch opgeslagen in Downloads. Op een iPhone kies je ‘Bewaar in Bestanden’ en daarna ‘Downloads’."
      },
      "runkeeper": {
        "label": "Van Runkeeper",
        "notice": "In de Runkeeper-app kun je geen losse GPX-bestanden downloaden. Via Safari of Chrome op je telefoon kun je je activiteiten wel exporteren.",
        "step1": "Open www.runkeeper.com in Safari of Chrome en log in.",
        "step2": "Open de desktopversie van de website. Op een iPhone tik je in Safari links van de adresbalk op de knop voor het paginamenu en daarna op ‘Vraag om desktopwebsite’. In Chrome op Android tik je op de drie puntjes en vink je ‘Desktopsite’ aan.",
        "step3": "Tik rechtsboven op het tandwiel, kies ‘Account Settings’ en daarna ‘Export Data’.",
        "step4": "Kies een begin- en einddatum waarin je activiteit valt en tik op ‘Export Data’. Wacht tot ‘Download Now!’ verschijnt en tik daarop. Open daarna het gedownloade zipbestand in Downloads of Bestanden om het uit te pakken. In de nieuwe map staan de GPX-bestanden die je bij Wallable kunt uploaden."
      },
      "garmin": {
        "label": "Van Garmin Connect",
        "notice": "De Garmin Connect-app heeft geen GPX-downloadknop. Gebruik daarom Safari of Chrome op je telefoon.",
        "step1": "Open connect.garmin.com in Safari of Chrome en log in met je Garmin-account.",
        "step2": "Open de desktopversie van de website. Op een iPhone tik je in Safari links van de adresbalk op het paginamenu en daarna op ‘Vraag om desktopwebsite’. In Chrome op Android tik je op de drie puntjes en vink je ‘Desktopsite’ aan.",
        "step3": "Open het menu, kies ‘Activiteiten’ en daarna ‘Alle activiteiten’. Tik op de activiteit die je op de poster wilt zetten.",
        "step4": "Tik rechtsboven op het tandwiel en kies ‘Exporteren naar GPX’. Het bestand wordt opgeslagen in Downloads of Bestanden."
      },
      "polar": {
        "label": "Van Polar Flow",
        "notice": "Gebruik Safari of Chrome op je telefoon. De GPX-export staat in de Polar Flow-website en niet in de app.",
        "step1": "Open flow.polar.com in Safari of Chrome en log in met je Polar-account.",
        "step2": "Open de desktopversie van de website. Op een iPhone tik je in Safari links van de adresbalk op het paginamenu en daarna op ‘Vraag om desktopwebsite’. In Chrome op Android tik je op de drie puntjes en vink je ‘Desktopsite’ aan.",
        "step3": "Open ‘Dagboek’ en tik op de training die je op de poster wilt zetten.",
        "step4": "Tik rechtsboven op ‘Exporteren’ en kies het GPX-bestand. Kies niet voor de zipversie. De GPX wordt opgeslagen in Downloads of Bestanden."
      }
    },
    "actions": {
      "viewDesign": "Bekijk ontwerp",
      "centerRoute": "Route centreren",
      "help": "Kunnen we helpen?"
    },
    "routesModal": {
      "title": "Selecteer een route",
      "description": "Hieronder vind je een lijst met routes die bij ons bekend zijn. Je kunt ze inladen door op de route te klikken.",
      "searchPlaceholder": "Zoek naar een route of sportevenement...",
      "noResults": "Helaas, we konden niets vinden. Probeer een andere zoekterm of neem contact op om een route toe te voegen."
    },
    "routeStep": {
      "title": "Kies een route",
      "description": "Kies een bestaande route of upload zelf één of meerdere routes vanuit jouw",
      "trackingApp": "sport tracking app",
      "chooseArchive": "Kies een route uit ons archief",
      "uploadOwn": "Upload je eigen route(s)",
      "yourRoutes": "Jouw route(s)",
      "labelsOverRoute": "Plaatsnamen boven route plaatsen",
      "unlockMap": "Kaart ontgrendelen",
      "unlockHelp": "Staat de kaart niet helemaal goed? Dan kun je deze ontgrendelen en met je muis of vingers zoomen en verslepen naar de juiste plaats."
    },
    "textStep": {
      "title": "Tekst op je ontwerp",
      "dateDistancePlaceholder": "Datum / Afstand",
      "nameTimePlaceholder": "Naam en tijd"
    },
    "styleStep": {
      "title": "Stijl van de kaart"
    },
    "routeOptions": {
      "settings": "Route-instellingen",
      "remove": "Route verwijderen",
      "thickness": "Dikte van de route",
      "routeColor": "Kleur van de route",
      "startColor": "Kleur van het startpunt",
      "endColor": "Kleur van het eindpunt",
      "showStart": "Startpunt tonen",
      "showEnd": "Eindpunt tonen",
      "removeConfirmation": "Weet je zeker dat je deze route wilt verwijderen?",
      "confirmRemove": "Ja, verwijder",
      "cancelRemove": "Nee, annuleer"
    },
    "shop": {
      "deliveryNote": "Meestal de volgende dag al in huis",
      "subtotal": "Subtotaal:",
      "saving": "Ontwerp opslaan...",
      "added": "Poster toegevoegd"
    },
    "errors": {
      "routeRequired": "Voeg minimaal één route toe voordat je het ontwerp opslaat.",
      "saveFailed": "Het ontwerp kon niet worden opgeslagen. Probeer het opnieuw.",
      "cartFailed": "Er ging iets mis, probeer het later opnieuw.",
      "startupFailed": "Je ontwerp kon niet volledig worden geladen. Probeer het opnieuw.",
      "routeFileFailed": "{name} kon niet worden ingeladen."
    },
    "navigation": {
      "routes": "Route(s)",
      "personalize": "Personaliseer",
      "product": "Product",
      "order": "Bestellen"
    },
    "defaults": {
      "location": "Plaatsnaam",
      "dateDistance": "Datum / 42.195 KM",
      "nameTime": "Jouw naam & tijd",
      "achievement": "Sportprestatie"
    }
  }
}
